import styled from "styled-components";

export const LinkElement = styled.a`
  font-weight: 700;
  font-size: 16px;
  padding: 12px 16px;
  color: ${props => props.disabled ? props.theme.colors.grayDark : props.theme.colors.primary};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;